import { PublicContentPage, publicPageHeading } from '../../features/public/PublicContentPage';
import { seoForPath } from '../../features/public/seoConfig';

export function PrivacyPage() {
  return (
    <PublicContentPage seo={seoForPath('/privacy')}>
      {publicPageHeading(
        'Privacy Policy',
        'How RideMaadi handles your information when you use our motorcycle group ride application.',
      )}
      <div className="space-y-8 text-sm leading-relaxed text-muted sm:text-base">
        <section>
          <h2 className="text-base font-semibold text-content">Information we collect</h2>
          <p className="mt-2">
            When you sign in with Google, we receive basic account information such as your name, email
            address, and profile picture to create and maintain your RideMaadi account. When you use the
            app, we store ride participation, group membership, profile details you provide, and location
            data you choose to share during active rides for coordination and safety features.
          </p>
        </section>
        <section>
          <h2 className="text-base font-semibold text-content">How we use information</h2>
          <p className="mt-2">
            We use your information to operate RideMaadi - including ride coordination, notifications,
            group management, and account authentication. We do not sell your personal information.
          </p>
        </section>
        <section>
          <h2 className="text-base font-semibold text-content">Sharing and visibility</h2>
          <p className="mt-2">
            Ride details, group membership, and rider profiles are visible only to authenticated users
            with appropriate access. Public marketing pages do not expose individual rides, groups, or
            rider profiles.
          </p>
        </section>
        <section>
          <h2 className="text-base font-semibold text-content">Data retention and deletion</h2>
          <p className="mt-2">
            We retain account and ride data while your account is active and as needed to provide the
            service. You may contact us to request account deletion or data correction.
          </p>
        </section>
        <section>
          <h2 className="text-base font-semibold text-content">Contact</h2>
          <p className="mt-2">
            For privacy questions about RideMaadi, contact the RideMaadi team through your usual support
            channel or the account owner for your riding group deployment.
          </p>
        </section>
        <p className="text-xs text-muted">Last updated: August 2026</p>
      </div>
    </PublicContentPage>
  );
}
